import React from 'react';
import clsx from 'clsx';
import { DragHandle } from './SortableItem.js';
export const DefaultView = ({ children, disabled, className, }) => {
    return (React.createElement("div", { className: clsx('truncate flex space-s-2 items-center', 'border border-line-subdued rounded-md p-2 px-2 bg-surface ', !disabled && 'hover:bg-surface-hovered', className) },
        React.createElement(DragHandle, { disabled: disabled }),
        React.createElement("div", { className: "grow min-w-0 flex space-s-2 items-center" }, children)));
};
//# sourceMappingURL=DefaultView.js.map